var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.training && _vm.training._id)?_c('mdb-tabs',{staticClass:"mb-3",attrs:{"active":this.active,"default":"","links":[
      { text: '과목별 평가'},
      { text: '학생별 평가'}
    ]},on:{"activeTab":_vm.onActiveTab}}):_vm._e(),(_vm.training && _vm.training._id)?_c('div',[_c('router-view')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }